import { CustomerService } from "../CustomerService";

import { NewsletterFooter } from "./Newsletter";

export const ThirdSection = () => (
  <div className="flex flex-col">
    <NewsletterFooter />
    <CustomerService className="hidden w-[18em] lg:flex xl:mt-6" />
  </div>
);
